module.exports = __webpack_public_path__ + "img/icon_call.bec6905c.svg";